import { IconButton, Tooltip } from '@mui/material';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useThemeMode, nextMode, type ThemeMode } from '../theme/ThemeModeProvider';

const LABELS: Record<ThemeMode, string> = {
  system: 'Theme: system (follows device)',
  light: 'Theme: light',
  dark: 'Theme: dark',
};

const ICONS: Record<ThemeMode, typeof SettingsBrightnessIcon> = {
  system: SettingsBrightnessIcon,
  light: LightModeIcon,
  dark: DarkModeIcon,
};

export function ThemeToggle() {
  const { mode, setMode } = useThemeMode();
  const label = LABELS[mode];
  const Icon = ICONS[mode];

  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        onClick={() => setMode(nextMode(mode))}
        aria-label={label}
        sx={{ width: 32, height: 32, borderRadius: 0, border: '1px solid var(--outline-strong)', mr: 1 }}
      >
        <Icon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
